export default __webpack_public_path__ + "static/media/7A.b41d594d.jpg";